import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AuthContext } from '../../../context/AuthContext';

const GSTDetails = ({ gstDetails }) => {
  const { apiGlobal } = useContext(AuthContext);
  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <p>GST No: {gstDetails?.gstNo}</p>
        </div>
        <div className="col-md-6">
          <p>GST Type: {gstDetails?.gstType}</p>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-md-6">
          <span className="text-muted">GST Proof</span>
          <br />
          <img
            src={`${apiGlobal}/images/agent/GST/${gstDetails?.gstProof}`}
            alt="gstProof"
            className="img-fluid"
            style={{ cursor: 'pointer', width: '390px' }}
          />
        </div>
        <div className="col-md-6">
          <span className="text-muted">Address Proof</span>
          <br />
          <img
            src={`${apiGlobal}/images/agent/GST/${gstDetails?.addressProof}`}
            alt="addressProof"
            className="img-fluid"
            style={{ cursor: 'pointer', width: '390px' }}
          />
        </div>
  
      </div>
  
    </div>
  
    
    );
}; 

GSTDetails.propTypes = {
    gstDetails: PropTypes.shape({
        gstNo: PropTypes.string.isRequired,
        gstType: PropTypes.string.isRequired,
        gstProof: PropTypes.string.isRequired,
        addressProof: PropTypes.string.isRequired,
    }).isRequired,
};


export default GSTDetails;
